import { render, staticRenderFns } from "./SystemCategory.vue?vue&type=template&id=3a62ecd2&scoped=true"
import script from "./SystemCategory.vue?vue&type=script&lang=js"
export * from "./SystemCategory.vue?vue&type=script&lang=js"
import style0 from "./SystemCategory.vue?vue&type=style&index=0&id=3a62ecd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a62ecd2",
  null
  
)

export default component.exports